import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["AboutCTA"] */ "/vercel/path0/src/app/about/about-cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderCTA"] */ "/vercel/path0/src/components/layout/header-cta.tsx");
